import type { AccountingExportPreview } from '@financiar/shared';
import { apiClient } from '../../api/client';
import { filenameFromDisposition, rethrowBlobAsApiError } from '../../lib/download';

export interface ContabilitateParams {
  companyId: string;
  dateFrom: string;
  dateTo: string;
}

export async function fetchContabilitatePreview(params: ContabilitateParams): Promise<AccountingExportPreview> {
  const { data } = await apiClient.get<AccountingExportPreview>('/accounting-export/preview', { params });
  return data;
}

/** Downloads the ZIP archive. No timeout: a first export of a quarter renders
 * every invoice PDF and can take a minute. */
export async function downloadContabilitateArchive(params: ContabilitateParams): Promise<{ blob: Blob; filename: string }> {
  try {
    const response = await apiClient.get<Blob>('/accounting-export/archive', { params, responseType: 'blob', timeout: 0 });
    const filename = filenameFromDisposition(response.headers['content-disposition'] as string | undefined);
    return { blob: response.data, filename: filename ?? `Contabilitate-${params.dateFrom}_${params.dateTo}.zip` };
  } catch (error) {
    return rethrowBlobAsApiError(error);
  }
}
